import React, { useState } from 'react';
import Messages from './Messages';
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';

const ChatBox = ({ chat }) => {
  const [message, setMessage] = useState('');
  const { senderName, senderOnlineStatus, senderImage } = chat;

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const badgeStyle = {
    bottom: '2px',
    right: '2px',
    backgroundColor: senderOnlineStatus ? 'green' : 'grey',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div className='flex flex-column border-1 surface-border border-round'>
      <div className="flex align-items-center border-bottom-1 surface-border p-0 lg:p-4">
        <div className="relative flex align-items-center mr-3">
          <Avatar className="p-overlay-badge" shape="circle" image={senderImage} size="xlarge">
            <span className="w-1rem h-1rem border-circle border-2 surface-border absolute" style={badgeStyle}>
              {!senderOnlineStatus && <i className="pi pi-times"></i>}
            </span>
          </Avatar>
        </div>
        <div className="mr-2">
          <span className="text-900 font-semibold block">{senderName}</span>
          <span className="text-700">Last active 1 hour ago</span>
        </div>
        <div className="flex align-items-center ml-auto">
          <button className="mr-3 p-button p-component p-button-icon-only p-button-outlined p-button-rounded p-button-secondary" type="button">
            <span className="p-button-icon p-c pi pi-phone"></span>
            <span className="p-button-label p-c">&nbsp;</span>
          </button>
          <button className="p-button p-component p-button-icon-only p-button-outlined p-button-rounded p-button-secondary" type="button">
            <span className="p-button-icon p-c pi pi-ellipsis-v"></span>
            <span className="p-button-label p-c">&nbsp;</span>
          </button>
        </div>
      </div>
      <div className="p-2 md:px-4 lg:px-6 lg:py-4 mt-2 overflow-y-auto" style={{ maxHeight: '50vh' }}>
        <Messages message="Hi" sentTime="22:18" senderName={senderName} senderImage={senderImage} status="sent" />
        <Messages message="Hello" sentTime="22:18" senderName={senderName} senderImage={senderImage} status="delivered" />
        <Messages message="Anyone there?" sentTime="22:28" senderName={senderName} senderImage={senderImage} status="read" />
        <Messages senderType="sender" senderName={senderName} message="Many of these experts condense their life experiences and wisdom into short quotes that are meaningful and encouraging. I feel like I'm skimming a biography and jumping to the juiciest parts. So, I gathered a list of my favorite quotes so you can reap all the benefits without the search." sentTime="22:18" senderImage={senderImage} />
        <Messages senderType="receiver" senderName={senderName} message="Hi, yes tell me" sentTime="22:18" senderImage={senderImage} status="read" />
        <Messages senderType="sender" senderName={senderName} message="Many of these experts condense their life experiences and wisdom into short quotes that are meaningful and encouraging. I feel like I'm skimming a biography and jumping to the juiciest parts. So, I gathered a list of my favorite quotes so you can reap all the benefits without the search." sentTime="22:18" senderImage={senderImage} status="read" />
      </div>
      <div className="p-1 md:p-1 lg:p-2 flex flex-column sm:flex-row align-items-center mt-2 border-top-1 surface-border gap-3">
        <InputTextarea autoResize value={message} onChange={handleInputChange} rows={3} cols={70} />
        <div className="flex w-full sm:w-auto gap-3">
          <Button label="Send" icon="pi pi-send" />
        </div>
      </div>
    </div>
  );
}

export default ChatBox;
